module.exports = __webpack_public_path__ + "img/wochenblatt-schlesien-herzen.b4a7a736.jpg";